import React from "react";

type CardProps = {
  reason: string;
  isFlipped: boolean;
  onFlip: () => void;
};

const Card: React.FC<CardProps> = ({ reason, isFlipped, onFlip }) => {
  return (
    <button
      className={`card ${isFlipped ? "flipped" : ""}`}
      onClick={onFlip}
      type="button"
      aria-pressed={isFlipped}
      aria-label={isFlipped ? "Hide reason" : "Reveal reason"}
    >
      <div className="card-inner">
        <div className="card-face card-front">
          <span>Reveal Me</span>
        </div>
        <div className="card-face card-back">
          <span>{reason}</span>
        </div>
      </div>
    </button>
  );
};

export default Card;
